/* eslint-disable */
import { mapGetters, mapMutations } from 'vuex';
export default {
  data() {
    return {
    	constants: {
	    cancer: {
	      CONST: 0.8908482,
  	    AVG: -0.0025437,
  	    AVG2: 0.0004768,
	    },

	    hlp: {
	      INTERCEPT: -0.1549581,
        SLOPEBMI: 0.0128784,
        SLOPEBMI2: -0.0001125,
	    },

	    htn: {
	      SLOPEBMI: 0.0141477,
        SLOPEBMI2: 0.0000699,
        INTERCEPT: -0.2285135,
        SBPDECR: 0.4,
        DBPDECR: 0.6,
	    },

      pcos: {
        SLOPEBMI: -0.2115518,
        INTERCEPT: 2.349742,
        SLOPEBMI2: 0.0068,
      },

	    nafld: {
	      SLOPEBMI: 0.04917,
        INTERCEPT: -1.053608333,
	    },

      oa: {
	      SLOPEBMI: [0.003255428571, 0.003653714286],
        INTERCEPT: [-0.05151285714, -0.01121142857],
	    },

      diab: {
        SLOPE: -0.0249615,
        SLOPE2: 0.0005354,
        INTERCEPT: 0.3107402,
      },

  	},
  }
},

  computed: {
    ...mapGetters('userData', ['userData']),
  },

  methods: {
    cancerRisk: function(bmi) {
      var risk = this.constants.cancer.CONST + this.constants.cancer.AVG*bmi + this.constants.cancer.AVG2*bmi*bmi;
      var calculatedRisk = risk.toFixed(3);
      return calculatedRisk;
    },

    hlpRisk: function (bmi) {
      return this.constants.hlp.INTERCEPT + this.constants.hlp.SLOPEBMI * bmi + this.constants.hlp.SLOPEBMI2 * (bmi * bmi);
    },

    htnRisk: function (bmi) {
     return this.constants.htn.INTERCEPT + this.constants.htn.SLOPEBMI * bmi + this.constants.htn.SLOPEBMI2 * (bmi * bmi);
    },

    pcosRisk: function (bmi) {
     return this.constants.pcos.INTERCEPT + this.constants.pcos.SLOPEBMI * bmi + this.constants.pcos.SLOPEBMI2 * (bmi * bmi);
    },

    nafldRisk: function(bmi) {
      var risk = (this.constants.nafld.INTERCEPT + (this.constants.nafld.SLOPEBMI * bmi));
      return Math.round(risk*1000)/1000;
    },

    oaRisk: function(bmi, gender) {
      var index=gender==='Male'?0:1;
      var prev = this.constants.oa.INTERCEPT[index] + this.constants.oa.SLOPEBMI[index] * bmi;
      prev = (prev < 0) ? 0 : (prev > 1) ? 1 : prev;
      var prevA = this.constants.oa.INTERCEPT[index] + this.constants.oa.SLOPEBMI[index] * 22;
      prevA = (prevA < 0) ? 0 : (prevA > 1) ? 1 : prevA;
      var prevB = this.constants.oa.INTERCEPT[index] + this.constants.oa.SLOPEBMI[index] * 23;
      prevB = (prevB < 0) ? 0 : (prevB > 1) ? 1 : prevB;
      var prevAvg = (prevA + prevB)/2;
      var risk = (prev / (1 - prev)) / (prevAvg / (1 - prevAvg));
      var r = (Math.round(risk * 100) / 100);
      return r;
    },

    diabRisk: function(bmi) {
      return this.constants.diab.INTERCEPT + this.constants.diab.SLOPE * bmi + this.constants.diab.SLOPE2 * (bmi * bmi);
    },
    
  }
};
